import React from "react";
import { connect } from "react-redux";
import { updateSelectedConfigurationTab } from "redux/operations";
import toggleUtils from "shared/toggleUtils";
import * as ingredientesOperations from "../../../cadastroIngredientes/redux/cadastroIngredientesOperations";
import {
  deveExibirFechamentoConsumo100kgPv,
  deveExibirSemiConfinamento,
} from "../../../shared/utils";
import * as operations from "../../redux/formulaOperations";
import CadastroFormulacaoPage from "./cadastroFormulacaoPage";

const CadastroFormulacaoContainer = (props) => {
  return <CadastroFormulacaoPage {...props} />;
};

const mapDispatchToProps = {
  obterTodosIngredientes: ingredientesOperations.obterTodasOperacoesIngrediente,
  criarFormula: operations.criarFormula,
  atualizaFormula: operations.atualizarFormula,
  obterEpocasFormula: operations.obterEpocasFormula,
  obterCategoriasFormula: operations.obterCategoriasFormula,
  copyFormula: operations.copyFormula,
  selecionaAba: updateSelectedConfigurationTab,
};

const mapStateToProps = (state) => {
  const { formula, fazenda, cadastroIngredientes } = state;

  const ingredientes = cadastroIngredientes.ingredientes.items
    ? cadastroIngredientes.ingredientes.items
    : [];

  return {
    ingredientes: ingredientes,
    formulasFazenda: formula.FormulasFazenda,
    categoriasRebanho: formula.categoriasFormula,
    epocas: formula.epocasFormula,
    exibirCreep: toggleUtils.isCreepActive(state.fazenda.Toggles),
    exibirSemiConfinamento: deveExibirSemiConfinamento(state),
    fazendaSelecionada: fazenda.FazendaSelecionada,
    exibirFechamentoConsumo100kgPv: deveExibirFechamentoConsumo100kgPv(state),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CadastroFormulacaoContainer);
